<!--
 * @Desc: 
 * @Author: lmy
 * @Date: 2025-07-11 09:48:57
 * @LastEditors: lmy
 * @LastEditTime: 2025-07-30 15:26:11
 * @FilePath: \henan-h5\src\App.vue
-->
<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
page {
  min-height: 100vh;
  background: #f6f8fb;
  padding-bottom: 60px;
}

</style>
